import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledDiv = styled.div`
    position: absolute;
    margin: 5px;
    line-height: 12px;
    height: 16px;
    color: white;
    background-color: #999;
    padding: 2px 4px;
    font-size: 11px;
    border-radius: 10px;
    i {
      font-size: 8px;
      margin-right: 5px;
      color: white;
    }
`;

const DetailsCount = ({ count, total }) => {
  if (count === total) {
    return null;
  }
  return (
    <StyledDiv>
      <i className='fas fa-filter' />
      <span>{`${count}/${total}`}</span>
    </StyledDiv>
  );
};
DetailsCount.propTypes = {
  count: PropTypes.number,
  total: PropTypes.number,
};

export default DetailsCount;
